<ng-template #TankGridAlarmTooltip>
  <tank-grid-alarm-tooltip [alarmList]="alarmList"></tank-grid-alarm-tooltip>
</ng-template>

<ng-template #alarmContent>
  <span><img class="h-4 w-4" [src]="alarmInfo.icon" />&nbsp;{{ alarmInfo.abbr }}</span>
</ng-template>

<ng-container *ngIf="alarmInfo">
  <div
    *ngIf="alarmList.length > 1; else noTooltip"
    class="flex"
    [tooltip]="TankGridAlarmTooltip"
    maxWidth="600px"
    contentType="template"
    tooltip-class="wide-tooltip"
    placement="bottom"
    show-delay="500"
    hide-delay="500"
    padding-left="10px"
    content-type="template"
  >
    <ng-container *ngTemplateOutlet="alarmContent"></ng-container>
  </div>

  <ng-template #noTooltip>
    <div class="flex">
      <ng-container *ngTemplateOutlet="alarmContent"></ng-container>
    </div>
  </ng-template>
</ng-container>
